import React, { useEffect, useState } from "react";
import { getLang, setLang } from "../lib/i18n";

export default function LangToggle({ light = false }) {
  const [lang, setL] = useState(getLang());
  useEffect(() => {
    const fn = () => setL(getLang());
    window.addEventListener("langchange", fn);
    return () => window.removeEventListener("langchange", fn);
  }, []);
  const flip = (l) => { setLang(l); setL(l); };
  return (
    <div className={`inline-flex rounded-full p-0.5 ${light ? "bg-white/20" : "bg-white/60 glass"}`} data-testid="lang-toggle">
      <button
        onClick={() => flip("te")}
        className={`px-3 py-1 text-xs uppercase tracking-wider rounded-full transition ${lang === "te" ? "bg-[#D4AF37] text-white" : (light ? "text-blush" : "text-plum")}`}
        data-testid="lang-te"
      >తె</button>
      <button
        onClick={() => flip("en")}
        className={`px-3 py-1 text-xs uppercase tracking-wider rounded-full transition ${lang === "en" ? "bg-[#D4AF37] text-white" : (light ? "text-blush" : "text-plum")}`}
        data-testid="lang-en"
      >EN</button>
    </div>
  );
}
